import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ButtonBase } from '../button-base/button-base.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'cgw-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  standalone: true,
  imports: [
    // Directives
    MatButton,
    MatIcon,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent extends ButtonBase {
  //#region I/O
  public readonly label = input.required<string>();
  //#endregion
}
